import { useState, useEffect } from 'react';

/**
 * Hook to detect if the app is running inside the native Despia app
 * Checks for "despia" in the user agent string
 */
import { Capacitor } from '@capacitor/core';

export function useIsDespia(): boolean {
  const [isDespia] = useState<boolean>(() => {
    if (typeof navigator !== 'undefined') {
      // Check for "despia" in UA OR if running in Capacitor native platform (replaces simulator check)
      return navigator.userAgent.toLowerCase().includes('despia') || Capacitor.isNativePlatform();
    }
    return false;
  });

  return isDespia;
}

/**
 * Hook to detect the current platform
 * Returns 'ios', 'android', or 'web'
 */
export function usePlatform(): 'ios' | 'android' | 'web' {
  const [platform] = useState<'ios' | 'android' | 'web'>(() => {
    if (typeof navigator !== 'undefined') {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.includes('despia')) {
        if (ua.includes('iphone') || ua.includes('ipad')) {
          return 'ios';
        }
        if (ua.includes('android')) {
          return 'android';
        }
      }
    }
    return 'web';
  });

  return platform;
}
